var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      loading: _vm.loading,
      "item-value": _vm.itemValue,
      "item-text": _vm.itemText,
      items: _vm.items,
      "search-input": _vm.search,
      disabled: _vm.disabled,
      outlined: "",
      dense: "",
      flat: "",
      "auto-select-first": "",
      "allow-overflow": false,
      "hide-no-data": _vm.noData,
      "hide-details": "",
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event
      },
      "update:search-input": [
        function ($event) {
          _vm.search = $event
        },
        _vm.handleInput,
      ],
      change: _vm.handleChange,
    },
    model: {
      value: _vm.select,
      callback: function ($$v) {
        _vm.select = $$v
      },
      expression: "select",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }